import { CourseTemplatesFacade } from './facades/course-templates.facade';
import { CourseTemplateService } from './services/course-templates.service';

export class CourseTemplatesModule {

  Store = new CourseTemplatesFacade();
  Services = CourseTemplateService;

}